export const useTapApi = () => {
    const { $api } = useNuxtApp()

    return {
        checkAlias(name) {
            return $api(`/proxy/tap-api.tap/api/v1/project/check-alias`, {
                query: { alias: name }
            })
        },

        createTap(alias, lang = 'RU') {
            return $api(`/proxy/tap-api.tap/api/v1/project`, {
                method: 'POST',
                query: { defaultLang: lang.toUpperCase() },
                body: {
                    alias,
                    is_searchable: true
                }
            })
        },

        copyTap(alias, id) {
            return $api(`/proxy/tap-api.tap/api/v1/project/copy/${id}`, {
                method: 'POST',
                body: { alias }
            })
        },

        changeTap(alias, id) {
            return $api(`/proxy/tap-api.tap/api/v1/project/${id}`, {
                method: 'PUT',
                body: { alias }
            })
        },

        deleteTap(id) {
            return $api(`/proxy/tap-api.tap/api/v1/project/${id}`, {
                method: 'DELETE'
            })
        },

        getTaps() {
            return $api(`/proxy/tap-api.tap/api/v1/project/list`)
        },

        search(query, mode) {
            return $api(`/proxy/tap-api.tap/api/v1/search`, {
                query: {
                    query,
                    mode
                }
            })
        },

        getRecentSearches() {
            return $api(`/proxy/tap-api.tap/api/v1/search/recent`)
        },

        deleteRecentSearch(id) {
            return $api(`/proxy/tap-api.tap/api/v1/search/recent/${id}`, {
                method: 'DELETE'
            })
        },

        clearRecentSearches() {
            return $api(`/proxy/tap-api.tap/api/v1/search/recent`, {
                method: 'DELETE'
            })
        },

        getPopularTaps() {
            return $api(`/proxy/tap-api.tap/api/v1/search/popular-taps`)
        },

        getPopularQueries() {
            return $api(`/proxy/tap-api.tap/api/v1/search/popular-queries`)
        },

        changeSearchVisibility(projectId, isSearchable) {
            return $api(`/proxy/tap-api.tap/api/v1/search-visibility/${projectId}`, {
                method: 'PUT',
                body: { isSearchable }
            })
        },

        checkHint() {
            return $api(`/proxy/tap-api.tap/api/v1/user-hint/check-all`)
        },

        checkHintStatus(code) {
            return $api(`/proxy/tap-api.tap/api/v1/user-hint/check/${encodeURIComponent(code)}`)
        },

        viewHint(code) {
            return $api(`/proxy/tap-api.tap/api/v1/user-hint/view/${code}`, {
                method: 'POST'
            })
        },

        sendComplaint(message, alias, recaptchaToken) {
            return $api(`/proxy/tap-api.tap/api/v1/feedback/complaint`, {
                method: 'POST',
                body: {
                    message,
                    alias,
                    ...(recaptchaToken && { recaptchaToken })
                }
            })
        },

        getProfileUser() {
            return $api(`/proxy/profile-api.bpmn/api/v1/profile/user`)
        },

        sendSuggestion(message, alias, allowContact, phone, fullName) {
            return $api(`/proxy/tap-api.tap/api/v1/feedback/suggestion`, {
                method: 'POST',
                body: {
                    message,
                    alias,
                    allowContact,
                    fullName,
                    ...(allowContact && { phone })
                }
            })
        },

        tapFull(alias, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/project-version-language/to-edit-by-alias/${alias}`, {
                method: 'POST',
                query: {
                    ...(lang && { lang: lang.toUpperCase() })
                }
            })
        },

        tapVersionFull(projectVersionId, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/project-version-language/to-edit/${projectVersionId}`, {
                method: 'POST',
                query: { ...(lang && {lang: lang.toUpperCase()}) }
            })
        },

        markProjectOpened(projectId) {
            return $api(`/proxy/tap-api.tap/api/v1/project/${projectId}/opened`, {
                method: 'POST'
            })
        },

        getLangSettings(alias) {
            return $api(`/proxy/tap-api.tap/api/v1/project-version-language-setting/all-by-alias/${alias}`)
        },

        // Ключевая функция для публичного SEO-превью
        tapPublicFull(alias, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/project/published/by-alias/${alias}`, {
                query: {
                    ...(lang && { lang: lang.toUpperCase() })
                }
            })
        },

        updateNameDescription(projectVersionId, name, description, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/project-version-language/${projectVersionId}`, {
                method: 'PUT',
                body: { name, description },
                query: {
                    ...(lang && { lang: lang.toUpperCase() })
                }
            })
        },

        updateBackground(projectVersionId, backgroundColor, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/project-version-language/${projectVersionId}`, {
                method: 'PUT',
                body: { backgroundColor },
                query: { lang: lang }
            })
        },

        updateSocials(projectVersionId, items, socialView, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/project-version-language/social/change-social/${projectVersionId}`, {
                method: 'POST',
                body: { items, socialView },
                query: { lang: lang }
            })
        },

        uploadTapImage(imageFileBase64, projectId, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/image/add-by-project/${projectId}`, {
                method: 'POST',
                body: { imageFileBase64, extension: 'jpeg' },
                query: { lang: lang }
            })
        },

        uploadBlockImage(projectVersionId, body, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/image/add-for-block/${projectVersionId}`, {
                method: 'POST', body, query: { lang }, retry: 0
            })
        },

        blockImage(projectVersionId, imageId, lang, draft = true) {
            return $api(`/proxy/tap-api.tap/api/v1/image/generate-path-by-project-version/${projectVersionId}/${imageId}`, {
                method: 'POST', query: { lang, draft }
            })
        },

        deleteBlockImage(projectVersionId, imageId, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/image/delete-for-block/${projectVersionId}/${imageId}`, {
                method: 'DELETE', query: { lang }, retry: 0
            })
        },

        tapImage(alias, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/image/generate-path-to-project-by-alias/${alias}`, {
                method: 'POST',
                query: { lang: lang, draft: true }
            })
        },

        publishTap(id, publish, lang = 'RU'){
            if (publish) {
                return $api(`/proxy/tap-api.tap/api/v1/project-version-language/publish/${id}`, {
                    method: 'POST',
                    query: { lang: lang }
                })
            }
            return $api(`/proxy/tap-api.tap/api/v1/project/unpublish/${id}`, {
                method: 'POST'
            })
        },

        addComponent(id, data, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/block-item/${id}`, {
                method: 'POST',
                body: data,
                query: { lang: lang }
            })
        },

        editComponent(id, data, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/block-item/${id}`, {
                method: 'PUT',
                body: data,
                query: { lang: lang }
            })
        },

        moveBlock(id, data, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/block/swap/${id}`, {
                method: 'PUT',
                body: data,
                query: { lang: lang }
            })
        },

        moveComponent(id, data, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/block-item/swap/${id}`, {
                method: 'PUT',
                body: data,
                query: { lang: lang }
            })
        },

        addColorToSwatch(id, color) {
            return $api(`/proxy/tap-api.tap/api/v1/project-version-color/${id}`, {
                method: 'POST',
                query: { color }
            })
        },

        getSwatchColors(id) {
            return $api(`/proxy/tap-api.tap/api/v1/project-version-color/${id}`)
        },

        removeComponent(id, uniq, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/block-item/${id}`, {
                method: 'DELETE',
                query: { uniqueId: uniq, lang: lang }
            })
        },

        removeBlock(id, uniq, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/block/${id}`, {
                method: 'DELETE',
                query: { uniqueId: uniq, lang: lang }
            })
        },

        deleteTapImage(id, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/image/delete-by-project/${id}`, {
                method: 'DELETE',
                query: { lang: lang }
            })
        },

        setDefaultLang(id, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/project-version/${id}`, {
                method: 'PUT',
                body: { "defaultLang": lang.toUpperCase() }
            })
        },

        setLanguages(id, data) {
            return $api(`/proxy/tap-api.tap/api/v1/project-version-language-setting/change/${id}`, {
                method: 'POST',
                body: data
            })
        },

        toggleLanguage(id, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/project-version-language-setting/toggle/${id}/${lang}`, {
                method: 'POST'
            })
        },

        resetLanguage(id, lang) {
            return $api(`/proxy/tap-api.tap/api/v1/project-version-language-setting/reset/${id}/${lang}`, {
                method: 'POST'
            })
        },

        getQRSettings(alias) {
            return $api(`/proxy/tap-api.tap/api/v1/project/qr-by-alias/${alias}`)
        },

        saveQRSettings(alias, settings) {
            return $api(`/proxy/tap-api.tap/api/v1/project/qr-by-alias/${alias}`, {
                method: 'POST',
                body: settings
            })
        },

        addClick(projectId, uniqueId, lang = 'RU') {
            return $api(`/proxy/tap-api.tap/api/v1/analytic/click-social/${projectId}`, {
                method: 'POST',
                body: {},
                query: {
                    uniqueId: uniqueId,
                    ...(lang && { lang: lang.toUpperCase() })
                }
            })
        },

        analytics(projectId, uniqueId, lang, customUniqueId) {
            return $api(`/proxy/tap-api.tap/api/v1/analytic/click-block/${projectId}`, {
                method: 'POST',
                query: { uniqueId, lang, customUniqueId }
            })
        },

        analyticsPdf(alias, lang, startDate, endDate) {
            return $api(`/proxy/tap-api.tap/api/v1/analytic/pdf/${alias}?lang=${lang}&startDate=${startDate}&endDate=${endDate}`,
                {
                    responseType: 'blob'
                }
            )
        },

        clicks(alias, lang, startDate, endDate) {
            return $api(`/proxy/tap-api.tap/api/v1/analytic/clicks-by-alias/${alias}?lang=${lang}&startDate=${startDate}&endDate=${endDate}`)
        },

        views(alias, lang, startDate, endDate) {
            return $api(`/proxy/tap-api.tap/api/v1/analytic/views-by-alias/${alias}?lang=${lang}&startDate=${startDate}&endDate=${endDate}`)
        }
    }
}
